class AdvertFeatureListController {
  constructor() {
    this.name = 'advertFeatureList';
    this.selected = null;
  }
}

export default AdvertFeatureListController;
